// Import model
import { UpdatePickListRequest } from '../models/UpdatePickListRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdatePickListRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdatePickListRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdatePickListRequest instance
   */
  static deserialize(json: string): UpdatePickListRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdatePickListRequest instance
   */
  static fromObject(obj: any): UpdatePickListRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdatePickListRequest');
    }


    const instance: UpdatePickListRequest = {
      isActive: obj['isActive'] as boolean | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      bins: obj['bins'] ? (obj['bins'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdatePickListRequest instances
   */
  static deserializeArray(json: string): UpdatePickListRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdatePickListRequest instance to a JSON string
   */
  static serialize(instance: UpdatePickListRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdatePickListRequest instance to a plain object
   */
  static toObject(instance: UpdatePickListRequest): any {
    return {
      'isActive': instance.isActive,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'bins': instance.bins?.map((item: any) =>
        item
      ),
      'description': instance.description,
      'name': instance.name,
    };
  }

  /**
   * Serializes an array of UpdatePickListRequest instances to a JSON string
   */
  static serializeArray(instances: UpdatePickListRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
